exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout[data-v-31752cdc]{position:relative;max-width:1720px;margin:0 auto;min-height:calc(100vh - 34px)}.layout-wrapper[data-v-31752cdc]{padding:17px 40px}@media (max-width:1280px){.layout[data-v-31752cdc]{max-width:1156px}}@media screen and (max-width:990px) and (min-width:460px){.layout[data-v-31752cdc]{max-width:535px}}@media (max-width:460px){.layout-wrapper[data-v-31752cdc]{padding:17px 15px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31752cdc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Layout.vue
// module id = 51
// module chunks = 0